import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=13f774a7&scoped=true&"
import script from "./Articles.vue?vue&type=script&lang=js&"
export * from "./Articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f774a7",
  null
  
)

export default component.exports